import { createCookie } from '../components/common/Cookie';
import {navigationTypes} from '../routes/views/Constants'
import { readQueryParameter } from './pageInfo';
import { FLEEK_STORE } from '../constants/constant';

const checkIsChildStore = (currentStore = '', allChildStores = []) => {
    const isChildStore = allChildStores.includes(currentStore.toLowerCase());
    return isChildStore;
};
const checkMilestoneDuration = (cookieName, milestoneCookieName, mileStoneCount, milestonePeriod) => {
    switch (mileStoneCount) {
        case 0: {
            createCookie(cookieName, true, milestonePeriod?.appLaunch)
            createCookie(milestoneCookieName, Number(mileStoneCount) + 1, 365)
            return true;
        }
        case 1: {
            console.log("INSIDE FIRST MILESTONE")
            createCookie(cookieName, true, milestonePeriod?.firstMilestone)
            createCookie(milestoneCookieName, Number(mileStoneCount) + 1, 365)
            return true;
        }
        case 2: {
            createCookie(cookieName, true, milestonePeriod?.secondMilestone)
            createCookie(milestoneCookieName, Number(mileStoneCount) + 1, 365)
            return true;
        }
        case 3: {
            createCookie(cookieName, true, milestonePeriod?.thirdMilestone)
            createCookie(milestoneCookieName, Number(mileStoneCount) + 1, 365)
            return true;
        }
        case 4: {
            createCookie(cookieName, true, milestonePeriod?.forthMilestone)
            createCookie(milestoneCookieName, Number(mileStoneCount) + 1, 365)
            return true;
        }
        default:
            return false;
    }
}
const setNavigationType = (
  navigationType,
  currentStore,
  isNewNavigation,
  childStores = [],
  isAjiogramLandingPage
) => {
    switch (navigationType) {
      case navigationTypes.CATEGORIES:
      case navigationTypes.SIDE_BAR:
        if(isNewNavigation && !checkIsChildStore(currentStore, childStores)) {
            return navigationTypes.CATEGORIES;
        }
        return navigationTypes.SIDE_BAR;
  
      case navigationTypes.TOP_BAR:
        if(isNewNavigation && !checkIsChildStore(currentStore, childStores)) {
          return currentStore === 'luxe' ? navigationTypes.TOP_BAR : navigationTypes.TOP_BAR;
        }
        return navigationTypes.TOP_BAR;
  
      case navigationTypes.BOTTOM_BAR:
        if (isNewNavigation && !checkIsChildStore(currentStore, childStores)) {
          if (isAjiogramLandingPage && currentStore === FLEEK_STORE) {
            return navigationTypes.BOTTOM_BAR_2;
          }

        return currentStore === FLEEK_STORE
          ? navigationTypes.BOTTOM_BAR
          : navigationTypes.BOTTOM_BAR_2;
        }
        return navigationTypes.BOTTOM_BAR;
  
      default:
        return '';
    }
  };
const isCMSPreview = () => {
  const { isPreview } = readQueryParameter(window.location);
  return window?.location?.pathname?.includes('/shop/newCMSPreview') && isPreview;
};
export const setCategoryImpressionPromoId = (promoId = '', localVariable = '') => {
  const getLocalData = JSON.parse(localStorage.getItem(localVariable)) || [];
  if(getLocalData?.indexOf(promoId) === -1) {
    getLocalData?.push(promoId);
    localStorage.setItem(localVariable, JSON.stringify(getLocalData));
  }
}

export const getBundleCategoryImpressionArray = (localVariable = '', includeData = false) => {
  let data = JSON.parse(localStorage.getItem(localVariable)) || {};
  return includeData ? data : (data?.promotionArray || []);
}
export const checkCategoryImpressionPromoId = (promoId = '', localVariable = '') => {
  const getLocalData = JSON.parse(localStorage.getItem(localVariable)) || [];
  const response = getLocalData?.indexOf(promoId) !== -1;
  return response;
}
export const setBundleCategoryImpressionArray = (localVariable = '', promotionArray = [], promotionData = {}) => {
  let getLocalData = JSON.parse(localStorage.getItem(localVariable)) || {};
  getLocalData = {
    ...getLocalData,
    promotionArray: promotionArray,
    promotionData: promotionData
  }
  localStorage.setItem(localVariable, JSON.stringify(getLocalData));
}
export const emptyBundleCategoryImpressionArray = (localVariable = '') => {
  localStorage.removeItem(localVariable);
}
export { checkIsChildStore, checkMilestoneDuration , setNavigationType, isCMSPreview}
